import React from 'react';
import { useDispatch } from 'react-redux';

import { OrderProduct } from '../../../../../../../api-client';
import { initWideFormOrderLine, initWideFormProduct, toggleWideFormDrawer } from '../../../../../../../slices/WideForm/wideFormSlice';
import { formatStandardDate } from '../../../../../../../utils/data-format-enchanters/datetime-enchanter';
import { orderTotalBySizes } from '../../../../../../../utils/data-format-enchanters/order-products-enchanter';

import './bv-destinations-card.scss';

interface IBVDestinationsCard {
    disabled?: boolean;
    product?: OrderProduct;
}

const BVDestinationsCard: React.FunctionComponent<IBVDestinationsCard> = ({ disabled, product }) => {
    const _handleProductQuantity = () => {
        if (product && product.sizes) {
            return (
                <div className="destination-card-quantity">
                    <span>
                        {product.sizes.map((x: any) => x.quantity).reduce((prev: any, next: any) => prev + next)}
                    </span>
                </div>
            );
        }

        return null;
    }

    const dispatch = useDispatch();

    const _handleDestinationClick = () => {
        if (disabled) {
            return;
        }

        if (product && product.id && product.rowId) {
            dispatch(initWideFormOrderLine(product.rowId));
            dispatch(initWideFormProduct(product.id));
            dispatch(toggleWideFormDrawer(true));
        }
    }

    return (
        <div className="bv-destination-card" onClick={_handleDestinationClick}>
            <div className="destination-card-header">
                {_handleProductQuantity()}

                <div className="destination-card-image">
                    <img src={product?.imageUrl} alt={product?.name} />
                </div>
            </div>

            <div className="destination-card-body">
                <div className="destination-card-address">
                    {product?.facility?.name} {product?.facility?.address}, {product?.facility?.city}
                </div>

                <div className="destination-heading">
                    {orderTotalBySizes(product?.sizes).amountFormat}
                </div>

                <span className="destination-secondary-heading">
                    {product && product.deliveryDate
                        ? `on ${formatStandardDate(product.deliveryDate)}`
                        : `-`
                    }
                </span>
            </div>
        </div>
    );
}
export default BVDestinationsCard;